import ajax from '@/lib/ajax';
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import { MigrationStatus, MigrationDetail, MigrationRollbackResult } from '@/models/Migrations/MigrationModels';
import store from '@/store';
import { AppModule } from '@/store/modules/app';

export interface IMigrationsState {
  loading: boolean;
  migrationStatus: MigrationStatus;
  currentMigrationDetail: MigrationDetail | null;
  loadingDialog: boolean;
}

@Module({ dynamic: true, store, name: 'Migrations', namespaced: true })
class Migrations extends VuexModule implements IMigrationsState {

  public loading = true;
  public migrationStatus: MigrationStatus = new MigrationStatus();
  public currentMigrationDetail: MigrationDetail | null = null;
  public loadingDialog = false;

  @Action
  public async getMigrations() {
    this.setLoading(true);
    ajax.get('/api/v1/sys/migrations')
      .then(response => {
        this.context.commit('setMigrationStatus', response.data);
        this.setLoading(false);
      })
      .catch(error => {
        AppModule.handleApiError(error);
        this.setLoading(false);
      });
  }

  @Action
  public async getMigrationDetail(version: number) {
    this.setLoadingDialog(true);
    ajax.get(`/api/v1/sys/migrations/${version}`)
      .then(response => {
        this.context.commit('setCurrentMigrationDetail', response.data);
        this.setLoadingDialog(false);
      })
      .catch(error => {
        AppModule.handleApiError(error);
        this.setLoadingDialog(false);
      });
  }

  @Action
  public async rollbackMigration(): Promise<MigrationRollbackResult | null> {
    this.setLoadingDialog(true);
    try {
      const response = await ajax.post('/api/v1/sys/migrations/rollback');
      this.setLoadingDialog(false);
      this.getMigrations();
      return response.data as MigrationRollbackResult;
    } catch (error) {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
      return null;
    }
  }

  @Mutation
  resetState() {
    this.migrationStatus = new MigrationStatus();
    this.currentMigrationDetail = null;
    this.loading = true;
    this.loadingDialog = false;
  }

  @Mutation
  private setLoading(isLoading: boolean) {
    this.loading = isLoading;
  }

  @Mutation
  private setLoadingDialog(isLoading: boolean) {
    this.loadingDialog = isLoading;
  }

  @Mutation
  private setMigrationStatus(status: MigrationStatus) {
    this.migrationStatus = status;
  }

  @Mutation
  private setCurrentMigrationDetail(detail: MigrationDetail) {
    this.currentMigrationDetail = detail;
  }
}

export const MigrationsModule = getModule(Migrations);
